/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PermissionsRouteImport } from './routes/permissions'
import { Route as SessionIdSessionRouteImport } from './routes/$sessionId/_session'
import { Route as DemoMotorcycleForRouteImport } from './routes/demo-motorcycle/$for'
import { Route as DemoIndexRouteImport } from './routes/demo/index'
import { Route as DemoForRouteImport } from './routes/demo/$for'
import { Route as SessionIdSessionIndexRouteImport } from './routes/$sessionId/_session/index'
import { Route as SessionIdSessionCanceledRouteImport } from './routes/$sessionId/_session/canceled'
import { Route as SessionIdSessionClaimRouteImport } from './routes/$sessionId/_session/claim'
import { Route as SessionIdSessionConsentRouteImport } from './routes/$sessionId/_session/consent'
import { Route as SessionIdSessionDamageRouteImport } from './routes/$sessionId/_session/damage'
import { Route as SessionIdSessionExtraClientDataRouteImport } from './routes/$sessionId/_session/extra-client-data'
import { Route as SessionIdSessionExtraEquipmentRouteImport } from './routes/$sessionId/_session/extra-equipment'
import { Route as SessionIdSessionFinalCheckRouteImport } from './routes/$sessionId/_session/final-check'
import { Route as SessionIdSessionFinishedRouteImport } from './routes/$sessionId/_session/finished'
import { Route as SessionIdSessionPrivacyPolicyRouteImport } from './routes/$sessionId/_session/privacy-policy'
import { Route as SessionIdSessionUnsupportedDeviceRouteImport } from './routes/$sessionId/_session/unsupported-device'
import { Route as SessionIdSession_debugErrorRouteImport } from './routes/$sessionId/_session/__debug/error'
import { Route as SessionIdSession_testSentryRouteImport } from './routes/$sessionId/_session/__test/sentry'
import { Route as SessionIdSessionClaimIndexRouteImport } from './routes/$sessionId/_session/claim/index'
import { Route as SessionIdSessionClaimNewRouteImport } from './routes/$sessionId/_session/claim/new'
import { Route as SessionIdSessionClaimOverviewRouteImport } from './routes/$sessionId/_session/claim/overview'
import { Route as SessionIdSessionDamageIndexRouteImport } from './routes/$sessionId/_session/damage/index'
import { Route as SessionIdSessionDamageAddMoreRouteImport } from './routes/$sessionId/_session/damage/add-more'
import { Route as SessionIdSessionDamageIntroRouteImport } from './routes/$sessionId/_session/damage/intro'
import { Route as SessionIdSessionDamageNewRouteImport } from './routes/$sessionId/_session/damage/new'
import { Route as SessionIdSessionDocumentsIndexRouteImport } from './routes/$sessionId/_session/documents/index'
import { Route as SessionIdSessionDocumentsStepRouteImport } from './routes/$sessionId/_session/documents/$step'
import { Route as SessionIdSessionDocumentsIntroRouteImport } from './routes/$sessionId/_session/documents/intro'
import { Route as SessionIdSessionErrorsIncompatibleDeviceRouteImport } from './routes/$sessionId/_session/errors/incompatible-device'
import { Route as SessionIdSessionExtraEquipmentIndexRouteImport } from './routes/$sessionId/_session/extra-equipment/index'
import { Route as SessionIdSessionExtraEquipmentSelectRouteImport } from './routes/$sessionId/_session/extra-equipment/select'
import { Route as SessionIdSessionGuideIndexRouteImport } from './routes/$sessionId/_session/guide/index'
import { Route as SessionIdSessionGuideStepRouteImport } from './routes/$sessionId/_session/guide/$step'
import { Route as SessionIdSessionIntroIndexRouteImport } from './routes/$sessionId/_session/intro/index'
import { Route as SessionIdSessionIntroStepRouteImport } from './routes/$sessionId/_session/intro/$step'
import { Route as SessionIdSessionPermissionsGuideIndexRouteImport } from './routes/$sessionId/_session/permissions-guide/index'
import { Route as SessionIdSessionPermissionsResetGuideAndroidRouteImport } from './routes/$sessionId/_session/permissions-reset-guide/android'
import { Route as SessionIdSessionVideoIndexRouteImport } from './routes/$sessionId/_session/video/index'
import { Route as SessionIdSessionVideoStepRouteImport } from './routes/$sessionId/_session/video/$step'
import { Route as SessionIdSessionClaimPhotosSelectRouteImport } from './routes/$sessionId/_session/claim/photos/select'
import { Route as SessionIdSessionDamageEditPhotoIdRouteImport } from './routes/$sessionId/_session/damage/edit/$photoId'
import { Route as SessionIdSessionClaimMarkersMarkerIdDetailsRouteImport } from './routes/$sessionId/_session/claim/markers/$markerId/details'
import { Route as SessionIdSessionClaimPhotosPhotoIdNewMarkerRouteImport } from './routes/$sessionId/_session/claim/photos/$photoId/new-marker'

const PermissionsRoute = PermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionIdSessionRoute = SessionIdSessionRouteImport.update({
  id: '/$sessionId/_session',
  path: '/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoMotorcycleForRoute = DemoMotorcycleForRouteImport.update({
  id: '/demo-motorcycle/$for',
  path: '/demo-motorcycle/$for',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoIndexRoute = DemoIndexRouteImport.update({
  id: '/demo/',
  path: '/demo/',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoForRoute = DemoForRouteImport.update({
  id: '/demo/$for',
  path: '/demo/$for',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionIdSessionIndexRoute = SessionIdSessionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SessionIdSessionRoute,
} as any)
const SessionIdSessionCanceledRoute =
  SessionIdSessionCanceledRouteImport.update({
    id: '/canceled',
    path: '/canceled',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionClaimRoute = SessionIdSessionClaimRouteImport.update({
  id: '/claim',
  path: '/claim',
  getParentRoute: () => SessionIdSessionRoute,
} as any)
const SessionIdSessionConsentRoute = SessionIdSessionConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => SessionIdSessionRoute,
} as any)
const SessionIdSessionDamageRoute = SessionIdSessionDamageRouteImport.update({
  id: '/damage',
  path: '/damage',
  getParentRoute: () => SessionIdSessionRoute,
} as any)
const SessionIdSessionExtraClientDataRoute =
  SessionIdSessionExtraClientDataRouteImport.update({
    id: '/extra-client-data',
    path: '/extra-client-data',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionExtraEquipmentRoute =
  SessionIdSessionExtraEquipmentRouteImport.update({
    id: '/extra-equipment',
    path: '/extra-equipment',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionFinalCheckRoute =
  SessionIdSessionFinalCheckRouteImport.update({
    id: '/final-check',
    path: '/final-check',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionFinishedRoute =
  SessionIdSessionFinishedRouteImport.update({
    id: '/finished',
    path: '/finished',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionPrivacyPolicyRoute =
  SessionIdSessionPrivacyPolicyRouteImport.update({
    id: '/privacy-policy',
    path: '/privacy-policy',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionUnsupportedDeviceRoute =
  SessionIdSessionUnsupportedDeviceRouteImport.update({
    id: '/unsupported-device',
    path: '/unsupported-device',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSession_debugErrorRoute =
  SessionIdSession_debugErrorRouteImport.update({
    id: '/__debug/error',
    path: '/error',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSession_testSentryRoute =
  SessionIdSession_testSentryRouteImport.update({
    id: '/__test/sentry',
    path: '/sentry',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionClaimIndexRoute =
  SessionIdSessionClaimIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SessionIdSessionClaimRoute,
  } as any)
const SessionIdSessionClaimNewRoute =
  SessionIdSessionClaimNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => SessionIdSessionClaimRoute,
  } as any)
const SessionIdSessionClaimOverviewRoute =
  SessionIdSessionClaimOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => SessionIdSessionClaimRoute,
  } as any)
const SessionIdSessionDamageIndexRoute =
  SessionIdSessionDamageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SessionIdSessionDamageRoute,
  } as any)
const SessionIdSessionDamageAddMoreRoute =
  SessionIdSessionDamageAddMoreRouteImport.update({
    id: '/add-more',
    path: '/add-more',
    getParentRoute: () => SessionIdSessionDamageRoute,
  } as any)
const SessionIdSessionDamageIntroRoute =
  SessionIdSessionDamageIntroRouteImport.update({
    id: '/intro',
    path: '/intro',
    getParentRoute: () => SessionIdSessionDamageRoute,
  } as any)
const SessionIdSessionDamageNewRoute =
  SessionIdSessionDamageNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => SessionIdSessionDamageRoute,
  } as any)
const SessionIdSessionDocumentsIndexRoute =
  SessionIdSessionDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionDocumentsStepRoute =
  SessionIdSessionDocumentsStepRouteImport.update({
    id: '/documents/$step',
    path: '/documents/$step',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionDocumentsIntroRoute =
  SessionIdSessionDocumentsIntroRouteImport.update({
    id: '/documents/intro',
    path: '/documents/intro',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionErrorsIncompatibleDeviceRoute =
  SessionIdSessionErrorsIncompatibleDeviceRouteImport.update({
    id: '/errors/incompatible-device',
    path: '/errors/incompatible-device',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionExtraEquipmentIndexRoute =
  SessionIdSessionExtraEquipmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SessionIdSessionExtraEquipmentRoute,
  } as any)
const SessionIdSessionExtraEquipmentSelectRoute =
  SessionIdSessionExtraEquipmentSelectRouteImport.update({
    id: '/select',
    path: '/select',
    getParentRoute: () => SessionIdSessionExtraEquipmentRoute,
  } as any)
const SessionIdSessionGuideIndexRoute =
  SessionIdSessionGuideIndexRouteImport.update({
    id: '/guide/',
    path: '/guide/',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionGuideStepRoute =
  SessionIdSessionGuideStepRouteImport.update({
    id: '/guide/$step',
    path: '/guide/$step',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionIntroIndexRoute =
  SessionIdSessionIntroIndexRouteImport.update({
    id: '/intro/',
    path: '/intro/',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionIntroStepRoute =
  SessionIdSessionIntroStepRouteImport.update({
    id: '/intro/$step',
    path: '/intro/$step',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionPermissionsGuideIndexRoute =
  SessionIdSessionPermissionsGuideIndexRouteImport.update({
    id: '/permissions-guide/',
    path: '/permissions-guide/',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionPermissionsResetGuideAndroidRoute =
  SessionIdSessionPermissionsResetGuideAndroidRouteImport.update({
    id: '/permissions-reset-guide/android',
    path: '/permissions-reset-guide/android',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionVideoIndexRoute =
  SessionIdSessionVideoIndexRouteImport.update({
    id: '/video/',
    path: '/video/',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionVideoStepRoute =
  SessionIdSessionVideoStepRouteImport.update({
    id: '/video/$step',
    path: '/video/$step',
    getParentRoute: () => SessionIdSessionRoute,
  } as any)
const SessionIdSessionClaimPhotosSelectRoute =
  SessionIdSessionClaimPhotosSelectRouteImport.update({
    id: '/photos/select',
    path: '/photos/select',
    getParentRoute: () => SessionIdSessionClaimRoute,
  } as any)
const SessionIdSessionDamageEditPhotoIdRoute =
  SessionIdSessionDamageEditPhotoIdRouteImport.update({
    id: '/edit/$photoId',
    path: '/edit/$photoId',
    getParentRoute: () => SessionIdSessionDamageRoute,
  } as any)
const SessionIdSessionClaimMarkersMarkerIdDetailsRoute =
  SessionIdSessionClaimMarkersMarkerIdDetailsRouteImport.update({
    id: '/markers/$markerId/details',
    path: '/markers/$markerId/details',
    getParentRoute: () => SessionIdSessionClaimRoute,
  } as any)
const SessionIdSessionClaimPhotosPhotoIdNewMarkerRoute =
  SessionIdSessionClaimPhotosPhotoIdNewMarkerRouteImport.update({
    id: '/photos/$photoId/new-marker',
    path: '/photos/$photoId/new-marker',
    getParentRoute: () => SessionIdSessionClaimRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/permissions': typeof PermissionsRoute
  '/$sessionId': typeof SessionIdSessionRouteWithChildren
  '/demo-motorcycle/$for': typeof DemoMotorcycleForRoute
  '/demo/$for': typeof DemoForRoute
  '/demo/': typeof DemoIndexRoute
  '/$sessionId/canceled': typeof SessionIdSessionCanceledRoute
  '/$sessionId/claim': typeof SessionIdSessionClaimRouteWithChildren
  '/$sessionId/consent': typeof SessionIdSessionConsentRoute
  '/$sessionId/damage': typeof SessionIdSessionDamageRouteWithChildren
  '/$sessionId/extra-client-data': typeof SessionIdSessionExtraClientDataRoute
  '/$sessionId/extra-equipment': typeof SessionIdSessionExtraEquipmentRouteWithChildren
  '/$sessionId/final-check': typeof SessionIdSessionFinalCheckRoute
  '/$sessionId/finished': typeof SessionIdSessionFinishedRoute
  '/$sessionId/privacy-policy': typeof SessionIdSessionPrivacyPolicyRoute
  '/$sessionId/unsupported-device': typeof SessionIdSessionUnsupportedDeviceRoute
  '/$sessionId/': typeof SessionIdSessionIndexRoute
  '/$sessionId/error': typeof SessionIdSession_debugErrorRoute
  '/$sessionId/sentry': typeof SessionIdSession_testSentryRoute
  '/$sessionId/claim/new': typeof SessionIdSessionClaimNewRoute
  '/$sessionId/claim/overview': typeof SessionIdSessionClaimOverviewRoute
  '/$sessionId/damage/add-more': typeof SessionIdSessionDamageAddMoreRoute
  '/$sessionId/damage/intro': typeof SessionIdSessionDamageIntroRoute
  '/$sessionId/damage/new': typeof SessionIdSessionDamageNewRoute
  '/$sessionId/documents/$step': typeof SessionIdSessionDocumentsStepRoute
  '/$sessionId/documents/intro': typeof SessionIdSessionDocumentsIntroRoute
  '/$sessionId/errors/incompatible-device': typeof SessionIdSessionErrorsIncompatibleDeviceRoute
  '/$sessionId/extra-equipment/select': typeof SessionIdSessionExtraEquipmentSelectRoute
  '/$sessionId/guide/$step': typeof SessionIdSessionGuideStepRoute
  '/$sessionId/intro/$step': typeof SessionIdSessionIntroStepRoute
  '/$sessionId/permissions-reset-guide/android': typeof SessionIdSessionPermissionsResetGuideAndroidRoute
  '/$sessionId/video/$step': typeof SessionIdSessionVideoStepRoute
  '/$sessionId/claim/': typeof SessionIdSessionClaimIndexRoute
  '/$sessionId/damage/': typeof SessionIdSessionDamageIndexRoute
  '/$sessionId/documents/': typeof SessionIdSessionDocumentsIndexRoute
  '/$sessionId/extra-equipment/': typeof SessionIdSessionExtraEquipmentIndexRoute
  '/$sessionId/guide/': typeof SessionIdSessionGuideIndexRoute
  '/$sessionId/intro/': typeof SessionIdSessionIntroIndexRoute
  '/$sessionId/permissions-guide/': typeof SessionIdSessionPermissionsGuideIndexRoute
  '/$sessionId/video/': typeof SessionIdSessionVideoIndexRoute
  '/$sessionId/claim/photos/select': typeof SessionIdSessionClaimPhotosSelectRoute
  '/$sessionId/damage/edit/$photoId': typeof SessionIdSessionDamageEditPhotoIdRoute
  '/$sessionId/claim/markers/$markerId/details': typeof SessionIdSessionClaimMarkersMarkerIdDetailsRoute
  '/$sessionId/claim/photos/$photoId/new-marker': typeof SessionIdSessionClaimPhotosPhotoIdNewMarkerRoute
}
export interface FileRoutesByTo {
  '/permissions': typeof PermissionsRoute
  '/demo-motorcycle/$for': typeof DemoMotorcycleForRoute
  '/demo/$for': typeof DemoForRoute
  '/demo': typeof DemoIndexRoute
  '/$sessionId/canceled': typeof SessionIdSessionCanceledRoute
  '/$sessionId/consent': typeof SessionIdSessionConsentRoute
  '/$sessionId/extra-client-data': typeof SessionIdSessionExtraClientDataRoute
  '/$sessionId/final-check': typeof SessionIdSessionFinalCheckRoute
  '/$sessionId/finished': typeof SessionIdSessionFinishedRoute
  '/$sessionId/privacy-policy': typeof SessionIdSessionPrivacyPolicyRoute
  '/$sessionId/unsupported-device': typeof SessionIdSessionUnsupportedDeviceRoute
  '/$sessionId': typeof SessionIdSessionIndexRoute
  '/$sessionId/error': typeof SessionIdSession_debugErrorRoute
  '/$sessionId/sentry': typeof SessionIdSession_testSentryRoute
  '/$sessionId/claim/new': typeof SessionIdSessionClaimNewRoute
  '/$sessionId/claim/overview': typeof SessionIdSessionClaimOverviewRoute
  '/$sessionId/damage/add-more': typeof SessionIdSessionDamageAddMoreRoute
  '/$sessionId/damage/intro': typeof SessionIdSessionDamageIntroRoute
  '/$sessionId/damage/new': typeof SessionIdSessionDamageNewRoute
  '/$sessionId/documents/$step': typeof SessionIdSessionDocumentsStepRoute
  '/$sessionId/documents/intro': typeof SessionIdSessionDocumentsIntroRoute
  '/$sessionId/errors/incompatible-device': typeof SessionIdSessionErrorsIncompatibleDeviceRoute
  '/$sessionId/extra-equipment/select': typeof SessionIdSessionExtraEquipmentSelectRoute
  '/$sessionId/guide/$step': typeof SessionIdSessionGuideStepRoute
  '/$sessionId/intro/$step': typeof SessionIdSessionIntroStepRoute
  '/$sessionId/permissions-reset-guide/android': typeof SessionIdSessionPermissionsResetGuideAndroidRoute
  '/$sessionId/video/$step': typeof SessionIdSessionVideoStepRoute
  '/$sessionId/claim': typeof SessionIdSessionClaimIndexRoute
  '/$sessionId/damage': typeof SessionIdSessionDamageIndexRoute
  '/$sessionId/documents': typeof SessionIdSessionDocumentsIndexRoute
  '/$sessionId/extra-equipment': typeof SessionIdSessionExtraEquipmentIndexRoute
  '/$sessionId/guide': typeof SessionIdSessionGuideIndexRoute
  '/$sessionId/intro': typeof SessionIdSessionIntroIndexRoute
  '/$sessionId/permissions-guide': typeof SessionIdSessionPermissionsGuideIndexRoute
  '/$sessionId/video': typeof SessionIdSessionVideoIndexRoute
  '/$sessionId/claim/photos/select': typeof SessionIdSessionClaimPhotosSelectRoute
  '/$sessionId/damage/edit/$photoId': typeof SessionIdSessionDamageEditPhotoIdRoute
  '/$sessionId/claim/markers/$markerId/details': typeof SessionIdSessionClaimMarkersMarkerIdDetailsRoute
  '/$sessionId/claim/photos/$photoId/new-marker': typeof SessionIdSessionClaimPhotosPhotoIdNewMarkerRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/permissions': typeof PermissionsRoute
  '/$sessionId/_session': typeof SessionIdSessionRouteWithChildren
  '/demo-motorcycle/$for': typeof DemoMotorcycleForRoute
  '/demo/$for': typeof DemoForRoute
  '/demo/': typeof DemoIndexRoute
  '/$sessionId/_session/canceled': typeof SessionIdSessionCanceledRoute
  '/$sessionId/_session/claim': typeof SessionIdSessionClaimRouteWithChildren
  '/$sessionId/_session/consent': typeof SessionIdSessionConsentRoute
  '/$sessionId/_session/damage': typeof SessionIdSessionDamageRouteWithChildren
  '/$sessionId/_session/extra-client-data': typeof SessionIdSessionExtraClientDataRoute
  '/$sessionId/_session/extra-equipment': typeof SessionIdSessionExtraEquipmentRouteWithChildren
  '/$sessionId/_session/final-check': typeof SessionIdSessionFinalCheckRoute
  '/$sessionId/_session/finished': typeof SessionIdSessionFinishedRoute
  '/$sessionId/_session/privacy-policy': typeof SessionIdSessionPrivacyPolicyRoute
  '/$sessionId/_session/unsupported-device': typeof SessionIdSessionUnsupportedDeviceRoute
  '/$sessionId/_session/': typeof SessionIdSessionIndexRoute
  '/$sessionId/_session/__debug/error': typeof SessionIdSession_debugErrorRoute
  '/$sessionId/_session/__test/sentry': typeof SessionIdSession_testSentryRoute
  '/$sessionId/_session/claim/new': typeof SessionIdSessionClaimNewRoute
  '/$sessionId/_session/claim/overview': typeof SessionIdSessionClaimOverviewRoute
  '/$sessionId/_session/damage/add-more': typeof SessionIdSessionDamageAddMoreRoute
  '/$sessionId/_session/damage/intro': typeof SessionIdSessionDamageIntroRoute
  '/$sessionId/_session/damage/new': typeof SessionIdSessionDamageNewRoute
  '/$sessionId/_session/documents/$step': typeof SessionIdSessionDocumentsStepRoute
  '/$sessionId/_session/documents/intro': typeof SessionIdSessionDocumentsIntroRoute
  '/$sessionId/_session/errors/incompatible-device': typeof SessionIdSessionErrorsIncompatibleDeviceRoute
  '/$sessionId/_session/extra-equipment/select': typeof SessionIdSessionExtraEquipmentSelectRoute
  '/$sessionId/_session/guide/$step': typeof SessionIdSessionGuideStepRoute
  '/$sessionId/_session/intro/$step': typeof SessionIdSessionIntroStepRoute
  '/$sessionId/_session/permissions-reset-guide/android': typeof SessionIdSessionPermissionsResetGuideAndroidRoute
  '/$sessionId/_session/video/$step': typeof SessionIdSessionVideoStepRoute
  '/$sessionId/_session/claim/': typeof SessionIdSessionClaimIndexRoute
  '/$sessionId/_session/damage/': typeof SessionIdSessionDamageIndexRoute
  '/$sessionId/_session/documents/': typeof SessionIdSessionDocumentsIndexRoute
  '/$sessionId/_session/extra-equipment/': typeof SessionIdSessionExtraEquipmentIndexRoute
  '/$sessionId/_session/guide/': typeof SessionIdSessionGuideIndexRoute
  '/$sessionId/_session/intro/': typeof SessionIdSessionIntroIndexRoute
  '/$sessionId/_session/permissions-guide/': typeof SessionIdSessionPermissionsGuideIndexRoute
  '/$sessionId/_session/video/': typeof SessionIdSessionVideoIndexRoute
  '/$sessionId/_session/claim/photos/select': typeof SessionIdSessionClaimPhotosSelectRoute
  '/$sessionId/_session/damage/edit/$photoId': typeof SessionIdSessionDamageEditPhotoIdRoute
  '/$sessionId/_session/claim/markers/$markerId/details': typeof SessionIdSessionClaimMarkersMarkerIdDetailsRoute
  '/$sessionId/_session/claim/photos/$photoId/new-marker': typeof SessionIdSessionClaimPhotosPhotoIdNewMarkerRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/permissions'
    | '/$sessionId'
    | '/demo-motorcycle/$for'
    | '/demo/$for'
    | '/demo/'
    | '/$sessionId/canceled'
    | '/$sessionId/claim'
    | '/$sessionId/consent'
    | '/$sessionId/damage'
    | '/$sessionId/extra-client-data'
    | '/$sessionId/extra-equipment'
    | '/$sessionId/final-check'
    | '/$sessionId/finished'
    | '/$sessionId/privacy-policy'
    | '/$sessionId/unsupported-device'
    | '/$sessionId/'
    | '/$sessionId/error'
    | '/$sessionId/sentry'
    | '/$sessionId/claim/new'
    | '/$sessionId/claim/overview'
    | '/$sessionId/damage/add-more'
    | '/$sessionId/damage/intro'
    | '/$sessionId/damage/new'
    | '/$sessionId/documents/$step'
    | '/$sessionId/documents/intro'
    | '/$sessionId/errors/incompatible-device'
    | '/$sessionId/extra-equipment/select'
    | '/$sessionId/guide/$step'
    | '/$sessionId/intro/$step'
    | '/$sessionId/permissions-reset-guide/android'
    | '/$sessionId/video/$step'
    | '/$sessionId/claim/'
    | '/$sessionId/damage/'
    | '/$sessionId/documents/'
    | '/$sessionId/extra-equipment/'
    | '/$sessionId/guide/'
    | '/$sessionId/intro/'
    | '/$sessionId/permissions-guide/'
    | '/$sessionId/video/'
    | '/$sessionId/claim/photos/select'
    | '/$sessionId/damage/edit/$photoId'
    | '/$sessionId/claim/markers/$markerId/details'
    | '/$sessionId/claim/photos/$photoId/new-marker'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/permissions'
    | '/demo-motorcycle/$for'
    | '/demo/$for'
    | '/demo'
    | '/$sessionId/canceled'
    | '/$sessionId/consent'
    | '/$sessionId/extra-client-data'
    | '/$sessionId/final-check'
    | '/$sessionId/finished'
    | '/$sessionId/privacy-policy'
    | '/$sessionId/unsupported-device'
    | '/$sessionId'
    | '/$sessionId/error'
    | '/$sessionId/sentry'
    | '/$sessionId/claim/new'
    | '/$sessionId/claim/overview'
    | '/$sessionId/damage/add-more'
    | '/$sessionId/damage/intro'
    | '/$sessionId/damage/new'
    | '/$sessionId/documents/$step'
    | '/$sessionId/documents/intro'
    | '/$sessionId/errors/incompatible-device'
    | '/$sessionId/extra-equipment/select'
    | '/$sessionId/guide/$step'
    | '/$sessionId/intro/$step'
    | '/$sessionId/permissions-reset-guide/android'
    | '/$sessionId/video/$step'
    | '/$sessionId/claim'
    | '/$sessionId/damage'
    | '/$sessionId/documents'
    | '/$sessionId/extra-equipment'
    | '/$sessionId/guide'
    | '/$sessionId/intro'
    | '/$sessionId/permissions-guide'
    | '/$sessionId/video'
    | '/$sessionId/claim/photos/select'
    | '/$sessionId/damage/edit/$photoId'
    | '/$sessionId/claim/markers/$markerId/details'
    | '/$sessionId/claim/photos/$photoId/new-marker'
  id:
    | '__root__'
    | '/permissions'
    | '/$sessionId/_session'
    | '/demo-motorcycle/$for'
    | '/demo/$for'
    | '/demo/'
    | '/$sessionId/_session/canceled'
    | '/$sessionId/_session/claim'
    | '/$sessionId/_session/consent'
    | '/$sessionId/_session/damage'
    | '/$sessionId/_session/extra-client-data'
    | '/$sessionId/_session/extra-equipment'
    | '/$sessionId/_session/final-check'
    | '/$sessionId/_session/finished'
    | '/$sessionId/_session/privacy-policy'
    | '/$sessionId/_session/unsupported-device'
    | '/$sessionId/_session/'
    | '/$sessionId/_session/__debug/error'
    | '/$sessionId/_session/__test/sentry'
    | '/$sessionId/_session/claim/new'
    | '/$sessionId/_session/claim/overview'
    | '/$sessionId/_session/damage/add-more'
    | '/$sessionId/_session/damage/intro'
    | '/$sessionId/_session/damage/new'
    | '/$sessionId/_session/documents/$step'
    | '/$sessionId/_session/documents/intro'
    | '/$sessionId/_session/errors/incompatible-device'
    | '/$sessionId/_session/extra-equipment/select'
    | '/$sessionId/_session/guide/$step'
    | '/$sessionId/_session/intro/$step'
    | '/$sessionId/_session/permissions-reset-guide/android'
    | '/$sessionId/_session/video/$step'
    | '/$sessionId/_session/claim/'
    | '/$sessionId/_session/damage/'
    | '/$sessionId/_session/documents/'
    | '/$sessionId/_session/extra-equipment/'
    | '/$sessionId/_session/guide/'
    | '/$sessionId/_session/intro/'
    | '/$sessionId/_session/permissions-guide/'
    | '/$sessionId/_session/video/'
    | '/$sessionId/_session/claim/photos/select'
    | '/$sessionId/_session/damage/edit/$photoId'
    | '/$sessionId/_session/claim/markers/$markerId/details'
    | '/$sessionId/_session/claim/photos/$photoId/new-marker'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PermissionsRoute: typeof PermissionsRoute
  SessionIdSessionRoute: typeof SessionIdSessionRouteWithChildren
  DemoMotorcycleForRoute: typeof DemoMotorcycleForRoute
  DemoForRoute: typeof DemoForRoute
  DemoIndexRoute: typeof DemoIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/permissions': {
      id: '/permissions'
      path: '/permissions'
      fullPath: '/permissions'
      preLoaderRoute: typeof PermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$sessionId/_session': {
      id: '/$sessionId/_session'
      path: '/$sessionId'
      fullPath: '/$sessionId'
      preLoaderRoute: typeof SessionIdSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo-motorcycle/$for': {
      id: '/demo-motorcycle/$for'
      path: '/demo-motorcycle/$for'
      fullPath: '/demo-motorcycle/$for'
      preLoaderRoute: typeof DemoMotorcycleForRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/': {
      id: '/demo/'
      path: '/demo'
      fullPath: '/demo/'
      preLoaderRoute: typeof DemoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/$for': {
      id: '/demo/$for'
      path: '/demo/$for'
      fullPath: '/demo/$for'
      preLoaderRoute: typeof DemoForRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$sessionId/_session/': {
      id: '/$sessionId/_session/'
      path: '/'
      fullPath: '/$sessionId/'
      preLoaderRoute: typeof SessionIdSessionIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/canceled': {
      id: '/$sessionId/_session/canceled'
      path: '/canceled'
      fullPath: '/$sessionId/canceled'
      preLoaderRoute: typeof SessionIdSessionCanceledRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/claim': {
      id: '/$sessionId/_session/claim'
      path: '/claim'
      fullPath: '/$sessionId/claim'
      preLoaderRoute: typeof SessionIdSessionClaimRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/consent': {
      id: '/$sessionId/_session/consent'
      path: '/consent'
      fullPath: '/$sessionId/consent'
      preLoaderRoute: typeof SessionIdSessionConsentRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/damage': {
      id: '/$sessionId/_session/damage'
      path: '/damage'
      fullPath: '/$sessionId/damage'
      preLoaderRoute: typeof SessionIdSessionDamageRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/extra-client-data': {
      id: '/$sessionId/_session/extra-client-data'
      path: '/extra-client-data'
      fullPath: '/$sessionId/extra-client-data'
      preLoaderRoute: typeof SessionIdSessionExtraClientDataRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/extra-equipment': {
      id: '/$sessionId/_session/extra-equipment'
      path: '/extra-equipment'
      fullPath: '/$sessionId/extra-equipment'
      preLoaderRoute: typeof SessionIdSessionExtraEquipmentRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/final-check': {
      id: '/$sessionId/_session/final-check'
      path: '/final-check'
      fullPath: '/$sessionId/final-check'
      preLoaderRoute: typeof SessionIdSessionFinalCheckRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/finished': {
      id: '/$sessionId/_session/finished'
      path: '/finished'
      fullPath: '/$sessionId/finished'
      preLoaderRoute: typeof SessionIdSessionFinishedRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/privacy-policy': {
      id: '/$sessionId/_session/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/$sessionId/privacy-policy'
      preLoaderRoute: typeof SessionIdSessionPrivacyPolicyRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/unsupported-device': {
      id: '/$sessionId/_session/unsupported-device'
      path: '/unsupported-device'
      fullPath: '/$sessionId/unsupported-device'
      preLoaderRoute: typeof SessionIdSessionUnsupportedDeviceRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/__debug/error': {
      id: '/$sessionId/_session/__debug/error'
      path: '/error'
      fullPath: '/$sessionId/error'
      preLoaderRoute: typeof SessionIdSession_debugErrorRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/__test/sentry': {
      id: '/$sessionId/_session/__test/sentry'
      path: '/sentry'
      fullPath: '/$sessionId/sentry'
      preLoaderRoute: typeof SessionIdSession_testSentryRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/claim/': {
      id: '/$sessionId/_session/claim/'
      path: '/'
      fullPath: '/$sessionId/claim/'
      preLoaderRoute: typeof SessionIdSessionClaimIndexRouteImport
      parentRoute: typeof SessionIdSessionClaimRoute
    }
    '/$sessionId/_session/claim/new': {
      id: '/$sessionId/_session/claim/new'
      path: '/new'
      fullPath: '/$sessionId/claim/new'
      preLoaderRoute: typeof SessionIdSessionClaimNewRouteImport
      parentRoute: typeof SessionIdSessionClaimRoute
    }
    '/$sessionId/_session/claim/overview': {
      id: '/$sessionId/_session/claim/overview'
      path: '/overview'
      fullPath: '/$sessionId/claim/overview'
      preLoaderRoute: typeof SessionIdSessionClaimOverviewRouteImport
      parentRoute: typeof SessionIdSessionClaimRoute
    }
    '/$sessionId/_session/damage/': {
      id: '/$sessionId/_session/damage/'
      path: '/'
      fullPath: '/$sessionId/damage/'
      preLoaderRoute: typeof SessionIdSessionDamageIndexRouteImport
      parentRoute: typeof SessionIdSessionDamageRoute
    }
    '/$sessionId/_session/damage/add-more': {
      id: '/$sessionId/_session/damage/add-more'
      path: '/add-more'
      fullPath: '/$sessionId/damage/add-more'
      preLoaderRoute: typeof SessionIdSessionDamageAddMoreRouteImport
      parentRoute: typeof SessionIdSessionDamageRoute
    }
    '/$sessionId/_session/damage/intro': {
      id: '/$sessionId/_session/damage/intro'
      path: '/intro'
      fullPath: '/$sessionId/damage/intro'
      preLoaderRoute: typeof SessionIdSessionDamageIntroRouteImport
      parentRoute: typeof SessionIdSessionDamageRoute
    }
    '/$sessionId/_session/damage/new': {
      id: '/$sessionId/_session/damage/new'
      path: '/new'
      fullPath: '/$sessionId/damage/new'
      preLoaderRoute: typeof SessionIdSessionDamageNewRouteImport
      parentRoute: typeof SessionIdSessionDamageRoute
    }
    '/$sessionId/_session/documents/': {
      id: '/$sessionId/_session/documents/'
      path: '/documents'
      fullPath: '/$sessionId/documents/'
      preLoaderRoute: typeof SessionIdSessionDocumentsIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/documents/$step': {
      id: '/$sessionId/_session/documents/$step'
      path: '/documents/$step'
      fullPath: '/$sessionId/documents/$step'
      preLoaderRoute: typeof SessionIdSessionDocumentsStepRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/documents/intro': {
      id: '/$sessionId/_session/documents/intro'
      path: '/documents/intro'
      fullPath: '/$sessionId/documents/intro'
      preLoaderRoute: typeof SessionIdSessionDocumentsIntroRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/errors/incompatible-device': {
      id: '/$sessionId/_session/errors/incompatible-device'
      path: '/errors/incompatible-device'
      fullPath: '/$sessionId/errors/incompatible-device'
      preLoaderRoute: typeof SessionIdSessionErrorsIncompatibleDeviceRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/extra-equipment/': {
      id: '/$sessionId/_session/extra-equipment/'
      path: '/'
      fullPath: '/$sessionId/extra-equipment/'
      preLoaderRoute: typeof SessionIdSessionExtraEquipmentIndexRouteImport
      parentRoute: typeof SessionIdSessionExtraEquipmentRoute
    }
    '/$sessionId/_session/extra-equipment/select': {
      id: '/$sessionId/_session/extra-equipment/select'
      path: '/select'
      fullPath: '/$sessionId/extra-equipment/select'
      preLoaderRoute: typeof SessionIdSessionExtraEquipmentSelectRouteImport
      parentRoute: typeof SessionIdSessionExtraEquipmentRoute
    }
    '/$sessionId/_session/guide/': {
      id: '/$sessionId/_session/guide/'
      path: '/guide'
      fullPath: '/$sessionId/guide/'
      preLoaderRoute: typeof SessionIdSessionGuideIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/guide/$step': {
      id: '/$sessionId/_session/guide/$step'
      path: '/guide/$step'
      fullPath: '/$sessionId/guide/$step'
      preLoaderRoute: typeof SessionIdSessionGuideStepRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/intro/': {
      id: '/$sessionId/_session/intro/'
      path: '/intro'
      fullPath: '/$sessionId/intro/'
      preLoaderRoute: typeof SessionIdSessionIntroIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/intro/$step': {
      id: '/$sessionId/_session/intro/$step'
      path: '/intro/$step'
      fullPath: '/$sessionId/intro/$step'
      preLoaderRoute: typeof SessionIdSessionIntroStepRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/permissions-guide/': {
      id: '/$sessionId/_session/permissions-guide/'
      path: '/permissions-guide'
      fullPath: '/$sessionId/permissions-guide/'
      preLoaderRoute: typeof SessionIdSessionPermissionsGuideIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/permissions-reset-guide/android': {
      id: '/$sessionId/_session/permissions-reset-guide/android'
      path: '/permissions-reset-guide/android'
      fullPath: '/$sessionId/permissions-reset-guide/android'
      preLoaderRoute: typeof SessionIdSessionPermissionsResetGuideAndroidRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/video/': {
      id: '/$sessionId/_session/video/'
      path: '/video'
      fullPath: '/$sessionId/video/'
      preLoaderRoute: typeof SessionIdSessionVideoIndexRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/video/$step': {
      id: '/$sessionId/_session/video/$step'
      path: '/video/$step'
      fullPath: '/$sessionId/video/$step'
      preLoaderRoute: typeof SessionIdSessionVideoStepRouteImport
      parentRoute: typeof SessionIdSessionRoute
    }
    '/$sessionId/_session/claim/photos/select': {
      id: '/$sessionId/_session/claim/photos/select'
      path: '/photos/select'
      fullPath: '/$sessionId/claim/photos/select'
      preLoaderRoute: typeof SessionIdSessionClaimPhotosSelectRouteImport
      parentRoute: typeof SessionIdSessionClaimRoute
    }
    '/$sessionId/_session/damage/edit/$photoId': {
      id: '/$sessionId/_session/damage/edit/$photoId'
      path: '/edit/$photoId'
      fullPath: '/$sessionId/damage/edit/$photoId'
      preLoaderRoute: typeof SessionIdSessionDamageEditPhotoIdRouteImport
      parentRoute: typeof SessionIdSessionDamageRoute
    }
    '/$sessionId/_session/claim/markers/$markerId/details': {
      id: '/$sessionId/_session/claim/markers/$markerId/details'
      path: '/markers/$markerId/details'
      fullPath: '/$sessionId/claim/markers/$markerId/details'
      preLoaderRoute: typeof SessionIdSessionClaimMarkersMarkerIdDetailsRouteImport
      parentRoute: typeof SessionIdSessionClaimRoute
    }
    '/$sessionId/_session/claim/photos/$photoId/new-marker': {
      id: '/$sessionId/_session/claim/photos/$photoId/new-marker'
      path: '/photos/$photoId/new-marker'
      fullPath: '/$sessionId/claim/photos/$photoId/new-marker'
      preLoaderRoute: typeof SessionIdSessionClaimPhotosPhotoIdNewMarkerRouteImport
      parentRoute: typeof SessionIdSessionClaimRoute
    }
  }
}

interface SessionIdSessionClaimRouteChildren {
  SessionIdSessionClaimNewRoute: typeof SessionIdSessionClaimNewRoute
  SessionIdSessionClaimOverviewRoute: typeof SessionIdSessionClaimOverviewRoute
  SessionIdSessionClaimIndexRoute: typeof SessionIdSessionClaimIndexRoute
  SessionIdSessionClaimPhotosSelectRoute: typeof SessionIdSessionClaimPhotosSelectRoute
  SessionIdSessionClaimMarkersMarkerIdDetailsRoute: typeof SessionIdSessionClaimMarkersMarkerIdDetailsRoute
  SessionIdSessionClaimPhotosPhotoIdNewMarkerRoute: typeof SessionIdSessionClaimPhotosPhotoIdNewMarkerRoute
}

const SessionIdSessionClaimRouteChildren: SessionIdSessionClaimRouteChildren = {
  SessionIdSessionClaimNewRoute: SessionIdSessionClaimNewRoute,
  SessionIdSessionClaimOverviewRoute: SessionIdSessionClaimOverviewRoute,
  SessionIdSessionClaimIndexRoute: SessionIdSessionClaimIndexRoute,
  SessionIdSessionClaimPhotosSelectRoute:
    SessionIdSessionClaimPhotosSelectRoute,
  SessionIdSessionClaimMarkersMarkerIdDetailsRoute:
    SessionIdSessionClaimMarkersMarkerIdDetailsRoute,
  SessionIdSessionClaimPhotosPhotoIdNewMarkerRoute:
    SessionIdSessionClaimPhotosPhotoIdNewMarkerRoute,
}

const SessionIdSessionClaimRouteWithChildren =
  SessionIdSessionClaimRoute._addFileChildren(
    SessionIdSessionClaimRouteChildren,
  )

interface SessionIdSessionDamageRouteChildren {
  SessionIdSessionDamageAddMoreRoute: typeof SessionIdSessionDamageAddMoreRoute
  SessionIdSessionDamageIntroRoute: typeof SessionIdSessionDamageIntroRoute
  SessionIdSessionDamageNewRoute: typeof SessionIdSessionDamageNewRoute
  SessionIdSessionDamageIndexRoute: typeof SessionIdSessionDamageIndexRoute
  SessionIdSessionDamageEditPhotoIdRoute: typeof SessionIdSessionDamageEditPhotoIdRoute
}

const SessionIdSessionDamageRouteChildren: SessionIdSessionDamageRouteChildren =
  {
    SessionIdSessionDamageAddMoreRoute: SessionIdSessionDamageAddMoreRoute,
    SessionIdSessionDamageIntroRoute: SessionIdSessionDamageIntroRoute,
    SessionIdSessionDamageNewRoute: SessionIdSessionDamageNewRoute,
    SessionIdSessionDamageIndexRoute: SessionIdSessionDamageIndexRoute,
    SessionIdSessionDamageEditPhotoIdRoute:
      SessionIdSessionDamageEditPhotoIdRoute,
  }

const SessionIdSessionDamageRouteWithChildren =
  SessionIdSessionDamageRoute._addFileChildren(
    SessionIdSessionDamageRouteChildren,
  )

interface SessionIdSessionExtraEquipmentRouteChildren {
  SessionIdSessionExtraEquipmentSelectRoute: typeof SessionIdSessionExtraEquipmentSelectRoute
  SessionIdSessionExtraEquipmentIndexRoute: typeof SessionIdSessionExtraEquipmentIndexRoute
}

const SessionIdSessionExtraEquipmentRouteChildren: SessionIdSessionExtraEquipmentRouteChildren =
  {
    SessionIdSessionExtraEquipmentSelectRoute:
      SessionIdSessionExtraEquipmentSelectRoute,
    SessionIdSessionExtraEquipmentIndexRoute:
      SessionIdSessionExtraEquipmentIndexRoute,
  }

const SessionIdSessionExtraEquipmentRouteWithChildren =
  SessionIdSessionExtraEquipmentRoute._addFileChildren(
    SessionIdSessionExtraEquipmentRouteChildren,
  )

interface SessionIdSessionRouteChildren {
  SessionIdSessionCanceledRoute: typeof SessionIdSessionCanceledRoute
  SessionIdSessionClaimRoute: typeof SessionIdSessionClaimRouteWithChildren
  SessionIdSessionConsentRoute: typeof SessionIdSessionConsentRoute
  SessionIdSessionDamageRoute: typeof SessionIdSessionDamageRouteWithChildren
  SessionIdSessionExtraClientDataRoute: typeof SessionIdSessionExtraClientDataRoute
  SessionIdSessionExtraEquipmentRoute: typeof SessionIdSessionExtraEquipmentRouteWithChildren
  SessionIdSessionFinalCheckRoute: typeof SessionIdSessionFinalCheckRoute
  SessionIdSessionFinishedRoute: typeof SessionIdSessionFinishedRoute
  SessionIdSessionPrivacyPolicyRoute: typeof SessionIdSessionPrivacyPolicyRoute
  SessionIdSessionUnsupportedDeviceRoute: typeof SessionIdSessionUnsupportedDeviceRoute
  SessionIdSessionIndexRoute: typeof SessionIdSessionIndexRoute
  SessionIdSession_debugErrorRoute: typeof SessionIdSession_debugErrorRoute
  SessionIdSession_testSentryRoute: typeof SessionIdSession_testSentryRoute
  SessionIdSessionDocumentsStepRoute: typeof SessionIdSessionDocumentsStepRoute
  SessionIdSessionDocumentsIntroRoute: typeof SessionIdSessionDocumentsIntroRoute
  SessionIdSessionErrorsIncompatibleDeviceRoute: typeof SessionIdSessionErrorsIncompatibleDeviceRoute
  SessionIdSessionGuideStepRoute: typeof SessionIdSessionGuideStepRoute
  SessionIdSessionIntroStepRoute: typeof SessionIdSessionIntroStepRoute
  SessionIdSessionPermissionsResetGuideAndroidRoute: typeof SessionIdSessionPermissionsResetGuideAndroidRoute
  SessionIdSessionVideoStepRoute: typeof SessionIdSessionVideoStepRoute
  SessionIdSessionDocumentsIndexRoute: typeof SessionIdSessionDocumentsIndexRoute
  SessionIdSessionGuideIndexRoute: typeof SessionIdSessionGuideIndexRoute
  SessionIdSessionIntroIndexRoute: typeof SessionIdSessionIntroIndexRoute
  SessionIdSessionPermissionsGuideIndexRoute: typeof SessionIdSessionPermissionsGuideIndexRoute
  SessionIdSessionVideoIndexRoute: typeof SessionIdSessionVideoIndexRoute
}

const SessionIdSessionRouteChildren: SessionIdSessionRouteChildren = {
  SessionIdSessionCanceledRoute: SessionIdSessionCanceledRoute,
  SessionIdSessionClaimRoute: SessionIdSessionClaimRouteWithChildren,
  SessionIdSessionConsentRoute: SessionIdSessionConsentRoute,
  SessionIdSessionDamageRoute: SessionIdSessionDamageRouteWithChildren,
  SessionIdSessionExtraClientDataRoute: SessionIdSessionExtraClientDataRoute,
  SessionIdSessionExtraEquipmentRoute:
    SessionIdSessionExtraEquipmentRouteWithChildren,
  SessionIdSessionFinalCheckRoute: SessionIdSessionFinalCheckRoute,
  SessionIdSessionFinishedRoute: SessionIdSessionFinishedRoute,
  SessionIdSessionPrivacyPolicyRoute: SessionIdSessionPrivacyPolicyRoute,
  SessionIdSessionUnsupportedDeviceRoute:
    SessionIdSessionUnsupportedDeviceRoute,
  SessionIdSessionIndexRoute: SessionIdSessionIndexRoute,
  SessionIdSession_debugErrorRoute: SessionIdSession_debugErrorRoute,
  SessionIdSession_testSentryRoute: SessionIdSession_testSentryRoute,
  SessionIdSessionDocumentsStepRoute: SessionIdSessionDocumentsStepRoute,
  SessionIdSessionDocumentsIntroRoute: SessionIdSessionDocumentsIntroRoute,
  SessionIdSessionErrorsIncompatibleDeviceRoute:
    SessionIdSessionErrorsIncompatibleDeviceRoute,
  SessionIdSessionGuideStepRoute: SessionIdSessionGuideStepRoute,
  SessionIdSessionIntroStepRoute: SessionIdSessionIntroStepRoute,
  SessionIdSessionPermissionsResetGuideAndroidRoute:
    SessionIdSessionPermissionsResetGuideAndroidRoute,
  SessionIdSessionVideoStepRoute: SessionIdSessionVideoStepRoute,
  SessionIdSessionDocumentsIndexRoute: SessionIdSessionDocumentsIndexRoute,
  SessionIdSessionGuideIndexRoute: SessionIdSessionGuideIndexRoute,
  SessionIdSessionIntroIndexRoute: SessionIdSessionIntroIndexRoute,
  SessionIdSessionPermissionsGuideIndexRoute:
    SessionIdSessionPermissionsGuideIndexRoute,
  SessionIdSessionVideoIndexRoute: SessionIdSessionVideoIndexRoute,
}

const SessionIdSessionRouteWithChildren =
  SessionIdSessionRoute._addFileChildren(SessionIdSessionRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PermissionsRoute: PermissionsRoute,
  SessionIdSessionRoute: SessionIdSessionRouteWithChildren,
  DemoMotorcycleForRoute: DemoMotorcycleForRoute,
  DemoForRoute: DemoForRoute,
  DemoIndexRoute: DemoIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
